import { useStore } from 'hooks/useStore';

export const useRoomHeaderTemplate = () => {
  const { JobPasteStore } = useStore();

  const onEditActionClick = (roomId: string, clickAction: (roomId: string) => void) => {
    const roomIndex = JobPasteStore.jobs?.findIndex(item => item.id === roomId);

    if (roomIndex === undefined || roomIndex === -1) {
      throw new Error('Room index out of bounds');
    }

    if (!JobPasteStore.activeIndexList.includes(roomIndex)) {
      JobPasteStore.setActiveIndex([...JobPasteStore.activeIndexList, roomIndex]);
    }

    clickAction(roomId);
  };

  return { JobPasteStore, onEditActionClick };
};
